export const LOGIN_ROOT_PATH = 'login' as const;

export enum LOGIN_TYPES {
  CALL = 'call',
  CODE = 'code',
  PASSWORD = 'password',
}
